import React from "react";
import ItemList from '../components/itemList/ItemList';

export default function Home({scroolRef, handleClick}) {

  return (
    <ItemList scroolRef={scroolRef} handleClickPagination={handleClick}/>
  );
}
